module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.video != null) ? _c('section', {
    attrs: {
      "id": "video"
    }
  }, [_c('iframe', {
    staticStyle: {
      "min-height": "600px"
    },
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.embedUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7708eee9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/Video.vue
// module id = 381
// module chunks = 0